import { Image, ImageProps, UserNotificationUtils } from 'UI-Dash-Commons-UI';
import React, { Component } from 'react';
import styled from 'styled-components';

import MenuSection from '../../../types/MenuSection';

import LeftSideMenuComponent from './LeftSideMenuComponent';
import TopDropdownMenuComponent from './TopDropdownMenuComponent';
import TopButtonsMenuComponent from './TopButtonsMenuComponent';
import MainNavigationMenuSpec from "../types/MainNavigationMenuSpec";
import { LeftMenuState } from "../types/MainNavigationState";
import UserNotificationsComponent from './UserNotificationsComponent';

const MenuArrow = require( '../images/menu_arrow.svg' );

export type MainNavigationComponentProps =
    {
        fetchMenuSpec: () => void,
        menuSpec: MainNavigationMenuSpec,
        leftMenuState: LeftMenuState,
        onSectionActivated: ( sectionSpec: MenuSection ) => void,
        onSectionActivatedIframeWindowLocation: ( currentSectionSpec: MenuSection, newSectionSpec: MenuSection ) => void,
        updateSideLeftMenuOpenState: ( isOpen: boolean ) => void,
        updateSideLeftMenuPinnedState: ( isPinnedOpen: boolean ) => void,
        updateSideLeftOpenSectionId: ( id: string | null ) => void,
    };

export default class MainNavigationComponent extends Component<MainNavigationComponentProps>
{

    componentDidMount(): void
    {
        this.runAdBlockerTest();
        this.props.fetchMenuSpec();
    }

    runAdBlockerTest = () =>
    {
        if ( !document.getElementById( 'applvnadblckrdetector862439' ) )
        {
            UserNotificationUtils.showAdBlockError( 'It looks like you have an ad blocker enabled. This may cause the AppLovin dashboard not to function as expected. Please disable it to remove this message.' );
        }
    };

    render()
    {
        const { menuSpec, leftMenuState, onSectionActivated, onSectionActivatedIframeWindowLocation, updateSideLeftOpenSectionId, updateSideLeftMenuOpenState, updateSideLeftMenuPinnedState } = this.props;

        const updateLeftMenuOpenAndPinnedStates = () =>
        {
            const wasOpen: boolean = leftMenuState.isOpen;

            updateSideLeftMenuOpenState( !wasOpen );
            updateSideLeftMenuPinnedState( !wasOpen );
        };

        return (
            <MainWrapper>
                <LeftSideMenuComponent
                    isOpen={leftMenuState.isOpen}
                    isPinnedOpen={leftMenuState.isPinnedOpen}
                    openSectionId={leftMenuState.openSectionId}
                    leftSideMenuSpec={menuSpec.leftSideMenu}
                    bottomLeftMenuSpec={menuSpec.bottomLeftMenu}
                    onUpdateMenuOpenState={updateSideLeftMenuOpenState}
                    onUpdateOpenSectionId={updateSideLeftOpenSectionId}
                    onSectionActivated={onSectionActivated}
                    onSectionActivatedIframeWindowLocation={onSectionActivatedIframeWindowLocation}
                />

                <MainSectionWrapper>
                    <TopBarWrapper>
                        <PinLeftSideMenuButton
                            src={MenuArrow}
                            alt={'Toggle Menu'}
                            width={'18px'}
                            height={'30px'}
                            isOpen={leftMenuState.isOpen}
                            onClick={updateLeftMenuOpenAndPinnedStates}/>

                        <NotificationWrapper>
                            <UserNotificationsComponent/>
                        </NotificationWrapper>

                        <TopDropdownMenuComponent
                            menuSpec={menuSpec.topDropdownMenu}
                            onSectionActivated={onSectionActivated}
                        />

                        <TopButtonsMenuComponent
                            menuSpec={menuSpec.topButtonsMenu}
                            onSectionActivated={onSectionActivated}
                        />
                    </TopBarWrapper>

                    {this.props.children}
                </MainSectionWrapper>
            </MainWrapper>
        );
    }
}

const MainWrapper = styled.main`
    display: flex;
    flex-direction: row;
`;

const TopBarWrapper = styled.div`
    display: flex;
    flex-direction: row;
    height: 48px;

    background-color: #333333;
`;


const MainSectionWrapper = styled.div`
    flex-grow: 1;
`;

const PinLeftSideMenuButton = styled<{ isOpen: boolean } & ImageProps>( ( { isOpen, ...rest } ) =>
    <Image {...rest} /> )`
    position: absolute;
    left: 43px;
    left: ${props => props.isOpen && '131px;'};

    margin: 5px 0 5px 0;

    cursor: pointer;

    img {
        transform: ${props => props.isOpen && 'rotate(180deg)'};
        transform: ${props => !props.isOpen && 'rotate(0deg)'};
        transition: transform 0.33s linear, left 0.33s linear;
    }
`;

const NotificationWrapper = styled.div`
    margin-left: auto;
`;